import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { AngularFireStorage, AngularFireUploadTask, AngularFireStorageReference } from '@angular/fire/compat/storage';
import { AngularFireFunctions } from '@angular/fire/compat/functions';
import { Sponsor } from '../models/sponsor';
import { Observable } from 'rxjs';
import { SnackBarIconService } from '../shared/snack-bar-icon/snack-bar-icon.service';
import { finalize } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class SponsorService {

  public spinner: boolean;

  public objectImage: any = null; // store input file for avatar
  public storedImage: any; // store url image for local preview

  private itemDoc: AngularFirestoreDocument<Sponsor>;
  private item: Observable<Sponsor>;

  constructor(private db: AngularFirestore,
    private fs: AngularFireStorage,
    private ff: AngularFireFunctions,
    private snackBar: SnackBarIconService) { }

  select() {
        return this.db.collection<Sponsor>('sbccv_sponsors', ref => ref.orderBy('name', 'asc')).snapshotChanges();            
  }

  selectById(id) {
    this.itemDoc = this.db.doc<Sponsor>('sbccv_sponsors/' + id);
    this.item = this.itemDoc.valueChanges();
    return this.item;
  }

  insert(entity: Sponsor) {
    delete entity.id;
    return this.db.collection('sbccv_sponsors').add(Object.assign({}, entity));
  }

  update(entity: Sponsor) {
    let id = entity.id;
    delete entity.id;
    return this.db.collection('sbccv_sponsors').doc(id).set(Object.assign({}, entity));
  }

  delete(entity_id: any) {
    return this.db.collection('sbccv_sponsors').doc(entity_id).delete();
  }

  makeMsgError(errorsCode) {

    let msgError: string = errorsCode
    switch (errorsCode) {
      case "auth/email-already-exists":
        msgError = "Este email já está em uso"
        break;
    }
    return msgError
  }

  previewImage(event) {

    if (event.target.files.length === 0)
      return;

    var mimeType = event.target.files[0].type;
    if (mimeType.match(/image\/*/) == null) {
      this.snackBar.openSnackBar("Apenas arquivos .png", '', 'info');
      return;
    }

    var reader = new FileReader();
    this.objectImage = event.target.files[0];
    reader.readAsDataURL(event.target.files[0]);
    reader.onload = (_event) => {
      this.storedImage = reader.result;
      return event.target.files[0];
    }
  }

  uploadImage(file, entity_id) {
    const fsRef: AngularFireStorageReference = this.fs.ref("images/sponsors/" + entity_id + ".png");
    const fsTask: AngularFireUploadTask = fsRef.put(file);

    fsTask.snapshotChanges().pipe(
      finalize(() => {
        fsRef.getDownloadURL().subscribe(url => {
          this.updateImage(entity_id, url)
        });
      }))
      .subscribe();
  }

  updateImage(entity_id: any, image: any) {
    return this.db.collection('sbccv_sponsors').doc(entity_id).set({ image: image }, { merge: true })
      .then(() => {
        this.objectImage = ""
      })
      .catch((err) => {
        console.log("erro upadate image: " + JSON.stringify(err))
      })
  }
  

}
